import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Shop from '@/components/Shop'
import Product from '@/components/Product'
import Blog from '@/components/Blog'
import Post from '@/components/Post'
import Cart from '@/components/Cart'
import Layout from '@/components/Layout'
import Terms from '@/components/Terms';

Vue.use(Router)

export default new Router({
        routes: [
            {
                path: '/',
                component: Layout,
                children: [
                    {
                        path: '/',
                        component: Shop,
                        name: 'Home'
                    },
                    {
                        path: '/kategoria/:slug',
                        component: Shop,
                        name: "Category"
                    },
                    {
                        path: '/produkt/:slug',
                        component: Product,
                        name: 'Product'
                    },
                    {
                        path: '/regulamin',
                        component: Terms,
                        name: 'Regulamin'
                    },
                    {
                        path: '/kontakt',
                        component: Post,
                        name: 'Post'
                    },
                    // {
                    //   path:'/cart',
                    //   component:Cart,
                    //   name:'Cart'
                    // }
                ]

            }
        ],
        mode: 'history'
    },
)



// WEBPACK FOOTER //
// ./src/router/index.js